import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";
import { LocalBusinessSchema } from './components/SchemaMarkup';
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import FAQPage from "./pages/FAQPage";
import UnfallgutachtenPage from "./pages/services/UnfallgutachtenPage";
import SchadengutachtenPage from "./pages/services/SchadengutachtenPage";
import FahrzeugbewertungPage from "./pages/services/FahrzeugbewertungPage";
import WertminderungPage from "./pages/services/WertminderungPage";
import NutzungsausfallPage from "./pages/services/NutzungsausfallPage";
import BeweissicherungPage from "./pages/services/BeweissicherungPage";
import FrankfurtPage from "./pages/locations/FrankfurtPage";
import WiesbadenPage from "./pages/locations/WiesbadenPage";
import MainzPage from "./pages/locations/MainzPage";
import StandortePage from "./pages/StandortePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <LocalBusinessSchema />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/uber-uns" element={<AboutPage />} />
              <Route path="/dienstleistungen" element={<ServicesPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<ImpressumPage />} />
              <Route path="/datenschutz" element={<DatenschutzPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/leistungen/unfallgutachten" element={<UnfallgutachtenPage />} />
              <Route path="/leistungen/schadengutachten" element={<SchadengutachtenPage />} />
              <Route path="/leistungen/fahrzeugbewertung" element={<FahrzeugbewertungPage />} />
              <Route path="/leistungen/wertminderung" element={<WertminderungPage />} />
              <Route path="/leistungen/nutzungsausfall" element={<NutzungsausfallPage />} />
              <Route path="/leistungen/beweissicherung" element={<BeweissicherungPage />} />
              <Route path="/kfz-gutachter-frankfurt" element={<FrankfurtPage />} />
              <Route path="/kfz-gutachter-wiesbaden" element={<WiesbadenPage />} />
              <Route path="/kfz-gutachter-mainz" element={<MainzPage />} />
              <Route path="/standorte" element={<StandortePage />} />
            </Routes>
          </main>
          <Footer />
          <MobileCTA />
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
